module.exports = require("okta-i18n-bundles");


//////////////////
// WEBPACK FOOTER
// external "okta-i18n-bundles"
// module id = 39
// module chunks = 0


// WEBPACK FOOTER //
// webpack:/external "okta-i18n-bundles"